export const routesConstants = {
  home: "/",
  projects: "/projects",
  updateProfile: "/update-profile",
  login: "/login",
  register: "/register",
  dashboard: "/dashboard",
  liveChat: "/live-chat",
  history: "/history",
  contacts: "/contacts",
  campaigns: "/campaigns",
  adsManager: "/ads",
  flow: "/flow",
  manage: "/manage",
  templateMessage: "/template-message",
  create: "/create",
  optinManagement: "/optin-management",
  liveChatSetting: "/live-chate-setting",
  userAttribute: "/user-attribute",
  cannedMessage: "/canned-message",
  agents: "/agents",
  tags: "/tags",
  analytics: "/analytics",
  apiKey: "/api-key",
  billingUsage: "/billing-usage",
  notificationPreference: "/notification-preferences",
  profile: "/profile",
  yourProfile: "/your-profile",
};

export const ImgaeConstants = {
  bgImage: "./assets/bgImages/bgImage.png",
};

export const templatelanguage = [
  {
    Afrikaans: "af",
  },
  {
    Albanian: "sq",
  },
  {
    Arabic: "ar",
  },
  {
    Azerbaijani: "az",
  },
  {
    Bengali: "bn",
  },
  {
    Bulgarian: "bg",
  },
  {
    Catalan: "ca",
  },
  {
    "Chinese (Simplified)": "zh_CN",
  },
  {
    "Chinese (Hong Kong)": "zh_HK",
  },
  {
    "Chinese (Taiwan)": "zh_TW",
  },
  {
    Croatian: "hr",
  },
  {
    Czech: "cs",
  },
  {
    Danish: "da",
  },
  {
    Dutch: "nl",
  },
  {
    English: "en",
  },
  {
    "English (UK)": "en_GB",
  },
  {
    "English (US)": "en_US",
  },
  {
    Estonian: "et",
  },
  {
    Filipino: "fil",
  },
  {
    Finnish: "fi",
  },
  {
    French: "fr",
  },
  {
    Georgian: "ka",
  },
  {
    German: "de",
  },
  {
    Greek: "el",
  },
  {
    Gujarati: "gu",
  },
  {
    Hausa: "ha",
  },
  {
    Hebrew: "he",
  },
  {
    Hindi: "hi",
  },
  {
    Hungarian: "hu",
  },
  {
    Indonesian: "id",
  },
  {
    Irish: "ga",
  },
  {
    Italian: "it",
  },
  {
    Japanese: "ja",
  },
  {
    Kannada: "kn",
  },
  {
    Kazakh: "kk",
  },
  {
    Kinyarwanda: "rw_RW",
  },
  {
    Korean: "ko",
  },
  {
    Kyrgyz: "ky_KG",
  },
  {
    Lao: "lo",
  },
  {
    Latvian: "lv",
  },
  {
    Lithuanian: "lt",
  },
  {
    Macedonian: "mk",
  },
  {
    Malay: "ms",
  },
  {
    Malayalam: "ml",
  },
  {
    Marathi: "mr",
  },
  {
    Norwegian: "nb",
  },
  {
    Persian: "fa",
  },
  {
    Polish: "pl",
  },
  {
    "Portuguese (Brazil)": "pt_BR",
  },
  {
    "Portuguese (Portugal)": "pt_PT",
  },
  {
    Punjabi: "pa",
  },
  {
    Romanian: "ro",
  },
  {
    Russian: "ru",
  },
  {
    Serbian: "sr",
  },
  {
    Slovak: "sk",
  },
  {
    Slovenian: "sl",
  },
  {
    Spanish: "es",
  },
  {
    "Spanish (Argentina)": "es_AR",
  },
  {
    "Spanish (Spain)": "es_ES",
  },
  {
    "Spanish (Mexico)": "es_MX",
  },
  {
    Swahili: "sw",
  },
  {
    Swedish: "sv",
  },
  {
    Tamil: "ta",
  },
  {
    Telugu: "te",
  },
  {
    Thai: "th",
  },
  {
    Turkish: "tr",
  },
  {
    Ukrainian: "uk",
  },
  {
    Urdu: "ur",
  },
  {
    Uzbek: "uz",
  },
  {
    Vietnamese: "vi",
  },
  {
    Zulu: "zu",
  },
];
